module.exports = __webpack_public_path__ + "media/images/icon-tag-close-74bf9c7999a4ede96bc93271ea3b7f0f.svg";